<!-- my-component.vue -->
<template>
  <div>
    <!-- Modal overlay with darkened background -->
    <div v-if="!developerMessageHidden" class="developer-message-overlay" @click="hideDeveloperMessage">
      <!-- Dark backdrop -->
      <div class="developer-message-backdrop"></div>

      <!-- Message box -->
      <div class="developer-message" :class="{ 'show': showMessage }" @click.stop>

        <div class="message-body">
          <div>
          <p>
            We're currently experiencing a temporary outage with our database server, which
            may cause some dictionary searches to fail or time out.
          </p>
          <p>
            We're aware of the issue and working with our hosting provider to resolve it.
            If a search doesn't return results, please try again in a little while. Sorry
            for the inconvenience, and thanks for your patience.
          </p>
          </div>
        </div>

        <div class="message-actions">
          <button class="btn-email" @click="sendEmail">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            Email Me
          </button>
          <button class="btn-dismiss" @click="hideDeveloperMessage">
            Got it!
          </button>
        </div>

        <p class="dismiss-hint">or click anywhere outside to dismiss</p>
      </div>
    </div>

    <!-- Small collapsed message when hidden -->
    <div v-else class="developer-message-collapsed">
      <div class="developer-message-warning">There is a temporary database outage. Sorry! Working on it.</div>
      <div>Questions? <a href="javascript:void(0)" onclick="window.location='mailto:andrew' + String.fromCharCode(64) + 'carterhughes@gmail.com?subject=Tibetan-Sanskrit-English Dictionary Support'">Email me.</a></div>
    </div>
  </div>
</template>

<script>

  const CURRENT_MESSAGE_NUMBER = 6;

  // Development flag - set to true to always show the message
  const FORCE_SHOW_IN_DEV = false;

  export default {
    name: 'DeveloperMessage',
    data() {
      return {
        developerMessageHidden: true,
        showMessage: false,
      };
    },
    async mounted() {
      // Force show if dev flag is enabled
      if (FORCE_SHOW_IN_DEV) {
        console.log('Developer message forced to show (FORCE_SHOW_IN_DEV = true)');
        this.developerMessageHidden = false;
        setTimeout(() => {
          this.showMessage = true;
        }, 300);
        return;
      }

      // Check if developer message has been hidden (persists across sessions)
      const hiddenMessageNumber = parseInt(localStorage.getItem(
        "developerMessageHidden",
      ));

      if (hiddenMessageNumber === CURRENT_MESSAGE_NUMBER) {
        console.log(`Developer message hidden for message number ${CURRENT_MESSAGE_NUMBER} = ${hiddenMessageNumber}`);
        this.developerMessageHidden = true;
      }
      else {
          this.developerMessageHidden = false;
          console.log(`Showing developer message for message number ${CURRENT_MESSAGE_NUMBER} = ${hiddenMessageNumber}`);

          // Animate in the message
          setTimeout(() => {
            this.showMessage = true;
          }, 300);
      }
    },
    // Other options like methods, computed, props, lifecycle hooks can go here
    methods: {
    hideDeveloperMessage() {
      this.showMessage = false;

      setTimeout(() => {
        this.developerMessageHidden = true;
        localStorage.setItem("developerMessageHidden", CURRENT_MESSAGE_NUMBER);
      }, 300);
    },
    sendEmail() {
      window.location = 'mailto:andrew' + String.fromCharCode(64) + 'carterhughes@gmail.com?subject=Tibetan-Sanskrit-English Dictionary Support';
    }
  },

  };
</script>

<style scoped>
  .developer-message-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: all;
  }

  .developer-message-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.65) 100%);
    backdrop-filter: blur(4px);
    animation: fadeIn 0.4s ease-out;
  }

  .developer-message {
    position: relative;
    max-width: 650px;
    width: 90%;
    border-radius: 16px;
    padding: 0;
    background: linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3),
                0 0 1px rgba(0, 0, 0, 0.1);
    z-index: 10000;
    opacity: 0;
    transform: scale(0.92) translateY(-30px);
    transition: opacity 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
                transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    overflow: hidden;
    max-height: 90vh;
    overflow-y: auto;
  }

  .developer-message.show {
    opacity: 1;
    transform: scale(1) translateY(0);
  }

  .message-header {
    background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
    color: white;
    padding: 28px 32px;
    display: flex;
    align-items: center;
    gap: 16px;
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
  }

  .header-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header-icon svg {
    color: white;
  }

  .message-header h3 {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 600;
    letter-spacing: -0.5px;
  }

  .message-body {
    padding: 32px;
    text-align: left;
  }

  .message-body p {
    margin: 0 0 16px 0;
    font-size: 1.05rem;
    line-height: 1.6;
    color: #2c3e50;
  }

  .message-body p:last-child {
    margin-bottom: 0;
  }

  .search-types-tip {
    background: linear-gradient(135deg, #fff9e6 0%, #fff4d6 100%);
    border-left: 4px solid #f59e0b;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
    display: flex;
    gap: 16px;
  }

  .tip-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .tip-content {
    flex: 1;
  }

  .tip-content h4 {
    margin: 0 0 12px 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #92400e;
  }

  .tip-content p {
    margin: 0 0 12px 0;
    font-size: 0.95rem;
    line-height: 1.5;
    color: #78350f;
  }

  .tip-content ul {
    margin: 12px 0;
    padding-left: 20px;
  }

  .tip-content li {
    margin-bottom: 8px;
    font-size: 0.95rem;
    line-height: 1.5;
    color: #78350f;
  }

  .tip-content li strong {
    color: #92400e;
    font-weight: 600;
  }

  .tip-note {
    margin-top: 12px;
    font-style: italic;
    font-size: 0.9rem !important;
    color: #a16207 !important;
  }

  .message-actions {
    padding: 0 32px 24px;
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  .btn-email {
    flex: 1;
    max-width: 200px;
    padding: 12px 24px;
    font-size: 1rem;
    font-weight: 600;
    color: white;
    background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  }

  .btn-email:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(74, 144, 226, 0.4);
  }

  .btn-email:active {
    transform: translateY(0);
  }

  .btn-dismiss {
    flex: 1;
    max-width: 200px;
    padding: 12px 24px;
    font-size: 1rem;
    font-weight: 600;
    color: #4a90e2;
    background: white;
    border: 2px solid #4a90e2;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .btn-dismiss:hover {
    background: #f0f7ff;
    transform: translateY(-2px);
  }

  .btn-dismiss:active {
    transform: translateY(0);
  }

  .dismiss-hint {
    padding: 0 32px 24px;
    margin: 0;
    font-size: 0.875rem;
    color: #95a5a6;
    text-align: center;
  }

  .developer-message-collapsed {
    width: 100%;
    border: none;
    background-color: transparent;
    text-align: center;
    padding: 10px 0;
    margin: 10px 0;
  }

  .developer-message-collapsed div {
    margin: 5px 0;
    color: #666;
    font-size: 0.95rem;
  }

  .developer-message-collapsed .developer-message-warning {
    font-weight: bold;
    color: #d32f2f;
    font-size: 1.1rem;
  }

  .developer-message-collapsed a {
    color: #4a90e2;
    text-decoration: underline;
  }

  .developer-message-collapsed a:hover {
    color: #357abd;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Responsive adjustments */
  @media (max-width: 600px) {
    .developer-message {
      width: 95%;
      max-width: none;
    }

    .message-header {
      padding: 24px;
    }

    .message-header h3 {
      font-size: 1.5rem;
    }

    .message-body {
      padding: 24px;
    }

    .message-body p {
      font-size: 1rem;
    }

    .message-actions {
      flex-direction: column;
      padding: 0 24px 20px;
    }

    .btn-email,
    .btn-dismiss {
      max-width: none;
      width: 100%;
    }
  }
</style>
